<div class="header">
</div>

<!-- <div *ngIf="params.header?.isCloseIcon" close-icon redSecondary (click)="cancel()">
    <app-icon size="min-small" icon-action >
        <i class="fal fa-times cursor-pointer"></i>
    </app-icon>
</div> -->

<div class="body" [attr.type]="type" modal> 
        
        <div nz-row nzJustify="center" >

            <nz-form-item nz-col [nzLg]="{ span: 24}" [nzXs]="{ span: 24}" body-icon>

                <app-icon size="large" icon redPrimary>
                    <i [class]="params.icon" class="color-primary"></i>
                </app-icon>
              
            </nz-form-item>

            <nz-form-item nz-col [nzLg]="{ span: 24}" [nzXs]="{ span: 24}" body-text>                
                <h3 text-title [innerHtml]="params.text"></h3>
                <span *ngIf="params.bodyText"  text-info>{{params.bodyText}} </span>                
            </nz-form-item>

            <nz-form-item nz-col [nzLg]="{ span: 24}" [nzXs]="{ span: 24}" [nzXs]="{span:24}" mb-20>
                
                <div button-group>
                    
                    <app-button *ngIf="params.cancelButton
                    Button" 
                    background="secondary" 
                    type="outline" 
                    shape="round" 
                    size="auto" 
                    height="small" 
                    class="mr-8" (click)="cancel()"
                    btn-cancel
                    >
                    
                        <app-icon red-icon size="tb-small">
                            <i [class]="params.cancelButton.icon"></i>
                        </app-icon>            
                        <p title-button>
                            {{params.cancelButton.text}}
                        </p>
                    </app-button>             
                    
                    <app-button  (click)="confirm()"
                        *ngIf="params.confirmButton" 
                        background="primary" 
                        type="solid" 
                        shape="round" 
                        size="auto" 
                        height="small" 
                        class="ml-8"
                        btn-confirm                        
                        >
                        
                        <app-icon red-icon size="tb-small">
                            <i [class]="params.confirmButton.icon"></i>
                        </app-icon>            
                        <p title-button>
                            {{params.confirmButton.text}}
                        </p>
                    
                    </app-button>
                </div>

            </nz-form-item>

        </div>

</div>


